// extracted by mini-css-extract-plugin
module.exports = {"downloading":"pokemons_downloading__zFFBX","tap":"pokemons_tap__1_XkX","container":"pokemons_container__1vaCm","errormsg":"pokemons_errormsg__1VmLS"};